export default class User {
    private name:string;
    private jwt:string|undefined;
    private id:number;
    private isAdmin:boolean;
    private sendMails:boolean;



	constructor($name: string,$id:number = 0,$isAdmin:boolean = false,$sendMails:boolean = false) {
		this.name = $name;
		this.id =$id;
		this.isAdmin = $isAdmin;
		this.sendMails = $sendMails;
	}



	public get $name(): string {
		return this.name;
	}


	public get $jwt(): string|undefined {
		return this.jwt;
	}


    public get $id(): number {
        return this.id;
    }

    public get $isAdmin(): boolean {
        return this.isAdmin;
    }

    public get $sendMails(): boolean {
        return this.sendMails;
    }


	public set $name(value: string) {
		this.name = value;
	}


	public set $jwt(value: string|undefined) {
		this.jwt = value;
	}


}